var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7415 0.712539C10.4827 -0.0349083 8.91607 -0.0349158 7.65722 0.712519L2.81504 3.58753C1.60124 4.30822 0.857178 5.61533 0.857178 7.02696V12.973C0.857178 14.3846 1.60123 15.6917 2.81503 16.4124L7.65721 19.2875C8.91607 20.0349 10.4827 20.0349 11.7415 19.2874L16.5836 16.4124C17.7973 15.6917 18.5414 14.3846 18.5414 12.973V7.02693C18.5414 5.61532 17.7973 4.30822 16.5836 3.58753L11.7415 0.712539ZM2.05373 7.927C2.05373 7.15185 2.8975 6.67143 3.5641 7.06705L7.63223 9.48144C8.54285 10.0219 9.10111 11.0024 9.10111 12.0613V16.9672C9.10111 17.7424 8.25717 18.2228 7.59057 17.827L3.52212 15.4114C2.61177 14.8709 2.05373 13.8905 2.05373 12.8318V7.927ZM11.8082 17.827C11.1416 18.2228 10.2977 17.7424 10.2977 16.9671V12.0613C10.2977 11.0024 10.8559 10.0219 11.7665 9.48144L15.8345 7.06711C16.5011 6.67148 17.3448 7.1519 17.3448 7.92706V12.8319C17.3448 13.8906 16.7868 14.8709 15.8765 15.4114L11.8082 17.827Z",
    fill: "#E22440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChains);
export default __webpack_public_path__ + "static/media/chains.51e0202a74de4f9efa4f9691bbb36df7.svg";
export { ForwardRef as ReactComponent };